export default {
  managerFeedback: 'Manager',
  placeholder: 'Add a comment...',
  noAttachments: 'None',
};
